const userActions = {
    login: 'LOGGED_IN',
    logOut: 'LOGGED_OUT'
}

export default userActions;